import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hero-profesionales',
  templateUrl: './hero-profesionales.component.html',
  styleUrls: ['./hero-profesionales.component.scss']
})
export class HeroProfesionalesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
